
export const EMAIL_EDITOR = 'EmailEditor';


